"use client";

function AI() {
    return null;
}

export default AI;
